import { Entity } from '@/store/shared/entity'
import IncomeDetail from '../incomedetail/entity';

export default class Income extends Entity<number>{
        //出运记录标识
        declareCustomsId:number;        
        //预付款
        prePaymentAmount:number;        
        //首付款应付款日
        prePaymentDate:Date;        
        //尾款应付款日
        restDate:Date;        
        //尾款
        restAmount:number;        
        //首付款是否已全部收汇
        isPrePaymentCompleted:boolean;        
        //是否两次付款
        isForTwicePay:boolean;

        //运编号
        ShippingNumber:string;
        //客户标识
        customerId:number;
        //客户名称
        customerName:string;
        //业务组
        businessGroup:string;
        //出运时间
        shipmentDate:Date;
        //结汇金额
        receiverAmount:number;
        //付款方式
        payment:string;
        // 是否预收款
        isAdvance: boolean;
        //状态
        status:string;
        //单证
        ownerId:number;
        //单证
        ownerName:string;
        //币种
        currency:string;
        currency_en:string;

        //到账明细
        incomeDetailList: Array<IncomeDetail>;
        //PO#
        poNumberList: Array<string>;

        constructor() {
                super();
                this.incomeDetailList = new Array<IncomeDetail>();
                this.poNumberList = new Array<string>();
        }
}